import React from "react";
import SubscriberDeletedTable from "../../../Components/SubscriberDeletedTable/SubscriberDeletedTable";


export const DeletedSubscribers = () => {
  return (
    <div className="container-fluid container-md">
      <SubscriberDeletedTable/>
    </div>
  );
};
